module.exports = __webpack_public_path__ + "img/builder-1.deacaae6.jpg";